<template>
	<v-icon :color="syncing ? 'default' : color">{{ icon }}</v-icon>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { CONNECTION_SYNC_FRAMES, CONNECTION_SYNC_FRAME_MS, connectionIcon } from '@/utils/ui/connectionIcon';

const props = defineProps({
	online: { type: Boolean, default: true },
	syncing: { type: Boolean, default: false },
	color: { type: String, default: undefined },
});

const frame = ref(null);
let timer = null;

const stop = () => {
	clearInterval(timer);
	timer = null;
	frame.value = null;
};

watch(
	() => props.online && props.syncing,
	(animate) => {
		stop();
		if (!animate) return;
		frame.value = 0;
		timer = setInterval(() => {
			frame.value = (frame.value + 1) % CONNECTION_SYNC_FRAMES.length;
		}, CONNECTION_SYNC_FRAME_MS);
	},
	{ immediate: true }
);

onBeforeUnmount(stop);

const icon = computed(() => connectionIcon(props.online, frame.value));
</script>
